import { styleConstants } from '@paywithextend/components'
import {
  base_colorAlert,
  base_colorSurface,
  grey450,
  notification_colorAlert,
  tag_colorTagDefaultBackground,
  tag_colorTagSevereBackground,
  tag_colorTagSevereText,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { css } from 'styled-components'

// Literal port of prototypes/extend-downgrade DowngradeGate counter card +
// tracks. Every value matches the prototype's text-styles.css / inline
// style values 1:1.
export default css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 8px;
  background: ${base_colorSurface};

  .VirtualCardLimitMeter-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
  }

  .VirtualCardLimitMeter-count-row {
    display: flex;
    align-items: baseline;
    gap: 4px;
  }

  /* text-heading-h1: 40 / 48 / 500 / letter-spacing 0 */
  .VirtualCardLimitMeter-count {
    font-family: ${styleConstants.fontFamilies.medium};
    font-size: 40px;
    line-height: 48px;
    font-weight: 500;
    letter-spacing: 0;
    color: ${text_colorTextPrimary};
    font-variant-numeric: tabular-nums;
  }

  &.over-limit .VirtualCardLimitMeter-count {
    color: ${notification_colorAlert};
  }

  /* text-paragraph-support-text-regular: 14 / 18 / 400 / letter-spacing 0 */
  .VirtualCardLimitMeter-limit-label {
    font-family: ${styleConstants.fontFamilies.regular};
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    letter-spacing: 0;
    color: ${text_colorTextSecondary};
  }

  /* text-paragraph-microcopy-medium: 12 / 16 / 500 / letter-spacing 0 */
  .VirtualCardLimitMeter-badge {
    display: inline-flex;
    align-items: center;
    height: 20px;
    padding: 0 4px;
    border-radius: 4px;
    font-family: ${styleConstants.fontFamilies.medium};
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    letter-spacing: 0;
  }

  .VirtualCardLimitMeter-badge--ok {
    gap: 4px;
    background: ${tag_colorTagDefaultBackground};
    color: ${text_colorTextPrimary};
  }

  .VirtualCardLimitMeter-badge--ok svg {
    width: 14px;
    height: 14px;
  }

  .VirtualCardLimitMeter-badge--ok svg path {
    stroke: ${text_colorTextPrimary};
  }

  .VirtualCardLimitMeter-badge--over {
    background: ${tag_colorTagSevereBackground};
    color: ${tag_colorTagSevereText};
  }

  /* Always reserve 20px below the bar for the over-cap tick label so card
     height does not jump when the user crosses the cap. */
  .VirtualCardLimitMeter-bar-wrapper {
    position: relative;
    padding-bottom: 20px;
  }

  .VirtualCardLimitMeter-bar {
    height: 10px;
    border-radius: 9999px;
    overflow: hidden;
    background: ${grey450};
  }

  .VirtualCardLimitMeter-bar-fill {
    height: 100%;
    border-radius: 9999px;
    background: ${text_colorTextPrimary};
    transition: width 300ms;
  }

  /* Respect prefers-reduced-motion (src/CLAUDE.md accessibility rule):
     users who opt out of motion get an instantaneous bar update instead
     of the 300ms ease-in. */
  @media (prefers-reduced-motion: reduce) {
    .VirtualCardLimitMeter-bar-fill {
      transition: none;
    }
  }

  &.over-limit .VirtualCardLimitMeter-bar-fill {
    background: ${base_colorAlert};
  }

  .VirtualCardLimitMeter-tick {
    position: absolute;
    top: -5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    transform: translateX(-50%);
  }

  .VirtualCardLimitMeter-tick-marker {
    width: 2px;
    height: 20px;
    border-radius: 1px;
    background: ${text_colorTextPrimary};
  }

  .VirtualCardLimitMeter-tick-label {
    font-family: ${styleConstants.fontFamilies.regular};
    font-size: 10px;
    line-height: 14px;
    font-weight: 400;
    letter-spacing: 0;
    color: ${text_colorTextSecondary};
  }
`
